import axios from 'axios';

// Separate API client for local backend (port 3001)
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_USERS_API_URL) {
    return process.env.REACT_APP_USERS_API_URL;
  }
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return '';
  }
  return 'http://localhost:3001';
};

const API_BASE_URL = getApiBaseUrl();

const repVisitLogsApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

repVisitLogsApi.interceptors.request.use(
  (config) => {
    const fullUrl = `${config.baseURL}${config.url}`;
    console.log(`[Rep Visit Logs API] ${config.method.toUpperCase()} ${fullUrl}`);
    return config;
  },
  (error) => Promise.reject(error)
);

repVisitLogsApi.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.code === 'ECONNREFUSED' || error.message === 'Network Error') {
      const errorMessage = `Cannot connect to backend server at ${API_BASE_URL}. Make sure the server is running with 'npm run dev' in the server directory.`;
      console.error('[Rep Visit Logs API] Connection Error:', errorMessage);
      return Promise.reject(new Error(errorMessage));
    }

    if (error.code === 'ECONNABORTED') {
      const errorMessage = `Request to ${API_BASE_URL} timed out. The server may be slow or unresponsive.`;
      console.error('[Rep Visit Logs API] Timeout Error:', errorMessage);
      return Promise.reject(new Error(errorMessage));
    }

    const errorMessage = error.response?.data?.message || error.message || 'An error occurred';
    console.error('[Rep Visit Logs API] Error:', errorMessage, error.response?.data);
    return Promise.reject(new Error(errorMessage));
  }
);

export default repVisitLogsApi;

